import React from "react";
import { CarouselBS } from "../BSGV/CarouselBS";

const projects = [
  {
    title: "Team 1",
    icon: "https://static.igem.wiki/teams/4888/wiki/education/mucovisidose.png",
  },
  {
    title: "Team 2",
    icon: "https://static.igem.wiki/teams/4888/wiki/education/les-perturbaterus-endocriniens-dans-l-eau.jpg",
  },
];

const TextBSGV = () => {
  return (
    <div className="mb-20">
      <div>
        <h2 id="BSGV" >BSGV </h2>
        <hr className="dividergeneral mb-5" />
        <p className="mb-2">BSGV, which stands for "Biologie Synthétique par les Gymnases Vaudois"
           or "Synthetic Biology by Vaudois High School," is a specialized 
           competition tailored for high school students in our local area. The 
           primary goal behind creating this competition was to introduce the 
           field of synthetic biology to younger students, given that it is 
           typically not part of the pre-university curriculum.
          </p>
          <p className="mb-2">
          Our intention went beyond merely introducing synthetic biology or our 
          project to the students. Instead, we aimed to fully immerse them in the
           world of iGEM, providing them with the opportunity to conceptualize their 
           own synthetic biology project. Recognizing that high school students may 
           not have access to the necessary resources and facilities to carry out 
           the entire engineering cycle and construct their project, we encouraged 
           them to focus exclusively on the ideation process. This involved generating 
           a project idea, documenting it thoroughly, and identifying potential areas
           for improvement in their proposed projects.
          </p>
          <p className="mb-2">
            The main objectives for students to develop through this project are as follows:
          </p>
          <ul
          className="ml-12 mb-10"
          style={{ listStyleType: "disc", listStylePosition: "inside" }}
        >
          <li>
          <mark>
              <b>Cultivate an Engineering Mindset:</b>
            </mark> Our foremost goal is to instill an
            engineering way of thinking in high school students before they
            embark on higher education. By engaging in synthetic biology
            projects, they gain early exposure to the problem-solving and
            innovation processes integral to engineering disciplines.
          </li>
          <li>
          <mark>
              <b>Application of Synthetic Biology Knowledge:</b>
            </mark> We aim to encourage
            students to learn and apply their acquired knowledge of synthetic
            biology. Participants are required to develop their own projects and
            articulate their ideas in written form, which deepens their
            understanding of the subject matter.
          </li>
          <li>
          <mark>
              <b>Effective Communication Skills:</b>
            </mark> To prepare students for potential
            careers in engineering, we challenge them to create posters and
            videos summarizing their projects. This not only helps them convey
            complex ideas effectively but also serves as a valuable skill set if
            they choose to pursue engineering studies.
          </li>
        </ul>
         
        
        <p className="mb-2">
        As this project is something that the students have not done before 
        we decided to give them multiple ways of support throughout the 6-week 
        project duration:
        </p>

        <ul
          className="ml-12 mb-10"
          style={{ listStyleType: "disc", listStylePosition: "inside" }}
        >
          <li>
          <mark>
              <b>Educational Videos:</b>
            </mark> We created and recorded a set of educational
            videos covering synthetic biology and related subjects. These videos
            are accessible to all on the BSGV YouTube channel. The topics
            include introductions to synthetic biology, engineering principles
            in this field, the central dogma of biology, DNA, RNA, proteins,
            organisms used in synthetic biology, tools employed, safety
            measures, recent advancements, and real-world examples from iGEM
            projects. The videos were shared with the students to educate them on
            the basis of synthetic biology which in turn will help the
            development of their project.
          </li>
          <li>
          <mark>
              <b>Online Guidance and Support:</b>
            </mark> Our team members were available to
            answer any questions the students had during the entire project
            duration. This online support ensured that participants had the
            resources and guidance they needed to succeed.
          </li>
        </ul>
        
        <p className="mb-2">
        The culmination of this initiative will be an award ceremony scheduled to 
        take place at EPFL at the end of November. During this event, students will 
        have the opportunity to showcase their projects to their peers, and medals 
        and prizes will be awarded. Constructive feedback will be provided both verbally
        and in written form, offering insights on their project and methodology to 
        the participants.
        </p>
        <p className="mb-2">
        At the award ceremony, we will meet the students in person for the first time, 
        engaging in discussions about their experiences and projects. We will also distribute 
        feedback forms to collect their input, enabling us to improve the overall experience
        for future participants.
        </p>
        <p className="mb-2">
          Our long-term vision is to transform BSGV into an annual event that attracts an 
          increasing number of students. We have already garnered interest from multiple 
          teachers and the DGEP (direction générale de l’enseignement post-obligatoire), 
          indicating the potential for future growth and development. We are exploring 
          possibilities to expand and refine the program, to further nurture students' 
          enthusiasm for synthetic biology and engineering education.
        </p>
        <p className="mb-2">
          By continuing to refine and expand BSGV, we aim to inspire and encourage
          the next generation of engineers and synthetic biologists, fostering a 
          culture of innovation and scientific exploration among high school students 
          in our region.
        </p>

        <h2 id="Projects" className="mt-20">Student projects </h2>
        <hr className="dividergeneral mb-5" />
        <p className="mb-2">
        Here are the most outstanding projects for this year's edition. 
        The teams respectively worked on Cystic fibrosis and Endocrine disruptors in water.
          </p>
        <div className="centered-image mb-20">
            <CarouselBS items={projects} title="Student projects" />
          </div>

        <h3 id="translation">Poster translation</h3>
        <div className="mr-12 ml-12">
        <h4 id="Cystic">Cystic fibrosis</h4>
        <p className="mb-2"> "Cystic fibrosis is an autosomal recessive genetic disease. It is characterized by 
          mucus in the respiratory digestive and genital tracts becoming extremely thick, sticky, 
          and viscous. This will obstruct the respiratory tract and accumulate waste products such 
          as CO2 and bacteria that will proliferate and create infections.</p>
        <p className="mb-2">This anomaly is caused by a mutation in the CFTR protein (transmembrane protein), 
          which enables the exchange of chloride Cl- ions between the inside and outside of the cell.</p>
        <p className="mb-2">The gene coding for this protein is mutated because it deletes the 508th amino acid in its chain 
          comprising 250,000 base pairs and 27 exons. The gene is located on chromosome 7.</p>
        <h6>Solution</h6>
        <p className="mb-2">Use a viral vector to insert the gene concerned and the enzyme that will delete the defective gene.
        Then increase translation efficiency using CRISPR Cas9 and SINEUP.
        </p>
        <h6>Process</h6>
        <div className="mr-10 ml-10">
        <ulb>
            <center>
              <li> Extract DNA from a virus (e.g. varicella-zoster) and then introduce the gene coding 
                for the CFTR-defective protein and the CRISPR Cas9 enzyme.</li>
              <li> Inject the non-pathogenic virus into the cells of the respiratory tract
              (as this is the most vulnerable area of all). The virus will enter the cells and multiply. </li>
              <li> The enzyme in the virus will remove the defective gene and replace it with the new one. </li>
              <li> To ensure distribution of the healthy gene, we then use the SINEUP the SINEUP method.</li>
            </center>
          </ulb>
        </div>
        <h6>Constraints</h6>
        <p className="mb-2">At first glance, we don't see any visible constraints. But it's not impossible 
        that the body may have a defensive reaction against the virus, or that there may be a small defect at the transcription stage.
        However, this will not normally happen. "
        </p>
       <br></br> 
        <h4 id="endocrine">Endocrine disruptors in water</h4>
        <h6>" The Problem</h6>
        <p className="mb-2">
        The estrogens in women's contraceptives are excreted in the urine, but are not eliminated in sewage 
        treatment plants, as they do not have the capacity to do so. These estrogens find their way into
        water and feminize aquatic species on a massive scale. They then reach humans via drinking water, 
        causing hormonal imbalances.
        </p>
        <h6>The Solution</h6>
        <p className="mb-2">There are two types of proteins capable of binding estrogens:
        <ul
          className="ml-12 mb-10"
          style={{ listStyleType: "disc", listStylePosition: "inside" }}
        >
          <li>
            Nuclear estrogen receptors (ER alpha and ER beta)
          </li>
          <li>
           Membrane estrogen receptors receptors (GPER, ER-X and Gq-ME)
          </li>
        </ul>
        </p> 
        <h6>The Process</h6>
        <p className="mb-2">These proteins would be transferred to bollards (large filters) in contaminated water from 
          wastewater treatment plants. The proteins would bind the estrogens present in the water via 
          their receptors. As decontamination progresses, the estrogen-laden bollards are removed and 
          replaced."</p>
        </div>

        <h2 id="Video-courses">Video courses</h2>
        <p className="mb-2"> To help the student in the development of their project we created a set of 
          video courses about the main concept of synthetic biology and other realted 
          subject. 
          The transcription of the videos both in French and English are available right below. The video visuals
          are currently available only in French, but if you wish to have them in a different language, please feel free 
          to contact us, and we'll be happy to assist you.

          <center>
              <details>
                <summary id="Who-are-we"><mark><b>Introduction and what is synthetic biology</b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/introduction-and-what-is-synthetic-biology.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="Intro-BSGV"><mark><b>Introduction to engineering in synthetic biology </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/introduction-to-engineering-in-synbio.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="central-dogma"><mark><b>The central dogma of biology </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/the-central-dogma.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="ADN"><mark><b>ADN </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/adn.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="ARN"><mark><b>ARN</b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/bsgv/arn.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="Proteins"><mark><b>Proteins </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/proteins.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="Organisms"><mark><b>Organisms used in synthetic biology </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/bsgv/organisms-in-synthetic-biology.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>

        <center>
              <details>
                <summary id="Tools"><mark><b>Tools used in synthetic biology </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/bsgv/tools-used-in-synthetic-biology.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="Safety-security"><mark><b>Safety and security </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/bsg/safety-and-security.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="History"><mark><b>History and recent discoveries </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/history-and-recent-disccoveries.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="Examples"><mark><b>Examples of iGEM projects </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/example-of-igem-projects.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
          </p>

      
        <h2 id="Documentation" className="mt-20">Documentation </h2>
        <hr className="dividergeneral mb-5" />
        <p className="mb-2">
        To encourage other teams to pursue educational initiatives in their 
        community, we are making all the documents we created for this 
        competition available in both French and English to everyone.
        </p>
        <h3 id="French">In French </h3>
        <center>
              <details>
                <summary id="communication"><mark><b>Communication </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/communication.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="for-the-students"><mark><b>For the students </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/for-the-students.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="For-the-teachers"><mark><b>For the teachers </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/for-the-teachers.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="How-to-register"><mark><b>How to register ? </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/how-to-register.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="Links"><mark><b>Useful Links </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/links.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="rule-book"><mark><b>Rule Book </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/rule-book.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="Who-are-we"><mark><b>Who are we ? </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/who-are-we.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>

        <h3 id="English">In English</h3>
        <center>
              <details>
                <summary id="communication"><mark><b>Communication </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/communication-english.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="for-the-students"><mark><b>For the students </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/for-the-students-english.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="For-the-teachers"><mark><b>For the teachers </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/for-the-teachers-english.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="How-to-register"><mark><b>How to register ? </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/how-to-register-english.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="Links"><mark><b>Useful Links </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/useful-links-english.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="rule-book"><mark><b>Rule Book </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/rule-book-english.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
        <center>
              <details>
                <summary id="Who-are-we"><mark><b>Who are we ? </b></mark></summary>
                <object data=
                    "https://static.igem.wiki/teams/4888/wiki/education/who-are-we-english.pdf"
                    width="800"
                    height="500">
                </object>
              </details>
        </center>
      </div>
    </div>
  );
};

export default TextBSGV;
